import React from 'react';
import '../styling/leaderboard.css';
import trophy from '../images/award.png';
// import first from '../images/first.png';
// import second from '../images/second.png';
// import third from '../images/third.png';
// import badge from '../images/badge.png';
import {getTop5Players} from './firebase'
import LeaderboardAccount from './LeaderboardAccount';


class LeaderBoard extends React.Component{

	state = {
		list: null
	}

	loadLeaderboard = async () => {
		var list = await getTop5Players();

		var objects = []

		console.log(list)

		for(var i = 0; i < list.length; i++) {
			const curDoc = list[i]

			const place = i+1;
			objects.push(<LeaderboardAccount key={place} place={place} name={curDoc.name} points={curDoc.stats.total.score}/>)
			console.log("Added one.")
		}
		return objects;
	}

	componentDidMount = async () => {
		this.setState({list: await this.loadLeaderboard()})
	}


    render(){
        return(
            <div className="LeaderBoard">
                    <div className="Title">
                    <img src ={trophy}/>
                    <h1>LeaderBoard</h1>
                    </div>
                

                <div className="leaderboard-container">

					{this.state.list}


                    {/* <div className="leaderboard-entry first-place">
                    <img src={first}/>
                    <h2>1st</h2>
                    <p className="leaderboard-user">@dodie_iro</p>
                    <p>5200 pts</p>
                    </div>

                    <div className="leaderboard-entry second-place">
                    <img src={second}/>
                    <h2>2nd</h2>
                    <p className="leaderboard-user">@JaimeOtraVez</p>
                    <p>4870 pts</p>

                    </div>

                    <div className="leaderboard-entry third-place">
                    <img src={third}/>
                    <h2>3rd</h2>
                    <p className="leaderboard-user">@PuentesCasey</p>
                    <p>4300 pts</p>

                    </div>

                    <div className="leaderboard-entry low-place">
                    <img src={badge}/>
                    <h2>4th</h2>
                    <p className="leaderboard-user">@dodie_iro</p>
                    <p>4280 pts</p>
                    </div>

                    <div className="leaderboard-entry low-place">
                    <img src={badge}/>
                    <h2>5th</h2>
                    <p className="leaderboard-user">@dodie_iro</p>
                    <p>3850 pts</p>
                    </div> */}

                </div>                
            </div>
        );
    }

}

export default LeaderBoard;